import React, { useContext } from 'react'
import PropTypes from "prop-types"
import { RichText } from 'prismic-reactjs'
import { ThemeProvider } from "styled-components"
import { Link as GatsbyLink } from "gatsby"

import { getLinkPropsFromReference } from '../../utils/link'

import { THEME_GREY } from '../../theme/theme'
import { getColor } from  '../../theme/colors'

import ConfigurationContext from '../../context/configuration-context';

import SectionContainer from '../section-container'

import { Inner, PreviousButton, NextButton, Pages } from './blog-pagination.styles'

const BlogPagination = ({page,totalPages,next,previous}) => {
	const configuration = useContext(ConfigurationContext);

	return (
		<ThemeProvider theme={(theme) => ({...theme,...THEME_GREY})}>
			<SectionContainer condenseTop>
				<Inner>
					{page > 1 && <PreviousButton as={GatsbyLink} to={previous}>{configuration.label_previous}</PreviousButton>}
					<Pages>{`${page} ${configuration.label_of} ${totalPages}`}</Pages>
					{page < totalPages && <NextButton as={GatsbyLink} to={next}>{configuration.label_next}</NextButton>}
				</Inner>
			</SectionContainer>
		</ThemeProvider>
	)
}

export default BlogPagination;